import { BidiModule } from '@angular/cdk/bidi';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridVirtualScrollViewportComponent } from './components/grid-virtual-scroll-viewport/grid-virtual-scroll-viewport.component';
import { GridVirtualForOfDirective } from './grid-virtual-for-of.directive';
import { CdkVirtualForOfOverrrideDirective } from './override/cdk-virtual-for-of-override.directive';

@NgModule({
	imports: [
		CommonModule,
		BidiModule,
		ScrollingModule
	],
	declarations: [
		GridVirtualScrollViewportComponent,
		GridVirtualForOfDirective,
		CdkVirtualForOfOverrrideDirective
	],
	exports: [
		GridVirtualScrollViewportComponent,
		GridVirtualForOfDirective,
		CdkVirtualForOfOverrrideDirective
	]
})
export class GridVirtualScrollViewportModule {}
